var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "订单详情",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        width: "80%",
        fullscreen: _vm.device === "mobile",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.dialogClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.dialogClose } },
                [_vm._v("关　闭")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-descriptions",
        {
          attrs: {
            title: "用户信息",
            size: "medium",
            column: 4,
            "label-style": { fontWeight: 600 },
          },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "ID" } }, [
            _vm._v(_vm._s(_vm.order.memberId)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "用户昵称" } }, [
            _vm._v(_vm._s(_vm.order.nickName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "绑定手机" } }, [
            _vm._v(_vm._s(_vm.order.mobile)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "用户编号" } }, [
            _vm._v(_vm._s(_vm.order.shareCode)),
          ]),
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "el-descriptions",
        {
          attrs: {
            title: "订单信息",
            size: "medium",
            colon: false,
            "label-style": { fontWeight: 600, width: "70px", margin: 0 },
          },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "订单号" } }, [
            _vm._v(_vm._s(_vm.order.orderNumber)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "支付单号" } }, [
            _vm._v(_vm._s(_vm.order.payNumber)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "订单状态" } }, [
            _vm._v(_vm._s(_vm.order.orderStatusName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "下单时间" } }, [
            _vm._v(_vm._s(_vm.order.orderTime)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "配送方式" } }, [
            _vm._v(_vm._s(_vm.order.deliveryMethodName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "发货时间" } }, [
            _vm._v(_vm._s(_vm.order.logisticsTime)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "商品总数" } }, [
            _vm._v(_vm._s(_vm.order.orderCount)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "商品总价" } }, [
            _vm._v(_vm._s(_vm.order.orderPrice)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "支付方式" } }, [
            _vm._v(_vm._s(_vm.paymentChannel[_vm.order.payChannel])),
          ]),
          _c("el-descriptions-item", { attrs: { label: "现金" } }, [
            _vm._v(
              _vm._s(
                `${
                  [75000, 77000].includes(_vm.order.orderType)
                    ? _vm.order.orderPrice
                    : "0.00"
                }`
              )
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "积分" } }, [
            _vm._v(_vm._s(_vm.order.orderPoint)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "券" } }, [
            _vm._v(_vm._s(_vm.order.orderCoupon)),
          ]),
          _vm.order.orderType !== 77000
            ? _c(
                "el-descriptions-item",
                { attrs: { label: "供应商", span: 2 } },
                [_vm._v(_vm._s(_vm.order.supplierName))]
              )
            : _vm._e(),
          _c("el-descriptions-item", { attrs: { label: "惊喜值" } }, [
            _vm._v(_vm._s(_vm.order.surpriseValue)),
          ]),
        ],
        1
      ),
      _c("el-divider"),
      _c(
        "el-descriptions",
        {
          attrs: {
            title: "商品信息",
            size: "medium",
            "label-style": { fontWeight: 600 },
          },
        },
        [
          _vm._l(_vm.order.products, function (item, index) {
            return [
              true
                ? _c(
                    "el-descriptions-item",
                    {
                      key: `name-${index}`,
                      attrs: { label: "商品名称", span: 2 },
                    },
                    [_vm._v(_vm._s(item.goodsName))]
                  )
                : _vm._e(),
              true
                ? _c(
                    "el-descriptions-item",
                    { key: `count-${index}`, attrs: { label: "数量" } },
                    [_vm._v(_vm._s(item.skuCount))]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
      _vm.order.deliveryMethod === 2
        ? [
            _c("el-divider"),
            _c(
              "el-descriptions",
              {
                attrs: {
                  title: "收货信息",
                  size: "medium",
                  column: 2,
                  "label-style": { fontWeight: 600 },
                },
              },
              [
                _c("el-descriptions-item", { attrs: { label: "收件人" } }, [
                  _vm._v(_vm._s(_vm.order.consigneeName)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "联系电话" } }, [
                  _vm._v(_vm._s(_vm.order.consigneeMobile)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "收货地址" } }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.order.consigneeRegion}${_vm.order.consigneeAddress}`
                    )
                  ),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.order.orderType === 77000
        ? [
            _c("el-divider"),
            _c(
              "el-descriptions",
              {
                attrs: {
                  title: "商家信息",
                  size: "medium",
                  column: 2,
                  "label-style": { fontWeight: 600 },
                },
              },
              [
                _c("el-descriptions-item", { attrs: { label: "商家名称" } }, [
                  _vm._v(_vm._s(_vm.order.consigneeName)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "联系电话" } }, [
                  _vm._v(_vm._s(_vm.order.consigneeMobile)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "商家地址" } }, [
                  _vm._v(
                    _vm._s(
                      `${_vm.order.consigneeRegion}${_vm.order.consigneeAddress}`
                    )
                  ),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.order.orderStatus > 21 && _vm.order.orderType !== 77000
        ? [
            _c("el-divider"),
            _c(
              "el-descriptions",
              {
                attrs: {
                  title: "物流信息",
                  size: "medium",
                  column: 2,
                  "label-style": { fontWeight: 600 },
                },
              },
              [
                _c("el-descriptions-item", { attrs: { label: "快递公司" } }, [
                  _vm._v(_vm._s(_vm.order.logisticsName)),
                ]),
                _c("el-descriptions-item", { attrs: { label: "快递单号" } }, [
                  _vm._v(_vm._s(_vm.order.logisticsNumber)),
                ]),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }